import { makeStyles } from '@mui/styles';
import DatePicker from 'apollo-react/components/DatePicker';
import moment from 'moment';
import React, { useState } from 'react';

import * as SSTypes from '../../../../constants/SSTypes';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { getUITA } from '../../../../utils/commonUtils';
import { DATE_FORMAT } from '../../../../utils/dateUtils';
import LookupField from '../../../LookupField';
import { INPUT_MAX_HEIGHT } from '../constants';

const useStyles = makeStyles({
  root: {
    marginTop: 0,
    width: 258,
  },
  input: {
    maxHeight: INPUT_MAX_HEIGHT,
    minHeight: 0,
  },
  datePickerInput: {
    maxHeight: INPUT_MAX_HEIGHT,
    width: 258,
    '& input': {
      marginTop: 0,
    },
  },
});

const Value = ({
  type,
  value,
  onChange,
  hidden,
  disabled,
  enableLookup,
  lookupValues = [''],
  onLookup,
  isOutPopover,
  showLabel,
  ...props
}) => {
  const [openCalendar, setOpenCalendar] = useState(false);

  const classes = useStyles();
  const translateString = useTranslation();

  const toggleOpenCalendar = () => {
    setOpenCalendar((value) => !value);
  };

  const handleChange = (date) => {
    onChange(date);
    toggleOpenCalendar();
  };

  if (hidden) {
    return <LookupField disabled={true} className={classes.root} />;
  }

  const date = value ? moment(value) : null;

  if (type === SSTypes.SSDateTime) {
    return (
      <div ui-ta={getUITA('FormCtrl SSDateBox Value')} className={classes.datePickerContainer}>
        <DatePicker
          {...props}
          margin="none"
          inputProps={{
            onClick: toggleOpenCalendar,
            className: classes.datePickerInput,
          }}
          dateFormat={DATE_FORMAT}
          placeholder={DATE_FORMAT}
          disabled={disabled}
          label={showLabel ? translateString('Value') : null}
          value={date}
          onChange={handleChange}
          disableCloseOnClickOutside
          open={openCalendar}
          todayText={translateString('Today')}
          PopperProps={{
            'ui-ta': getUITA('datepicker-popup'),
          }}
          TodayButtonProps={{
            'ui-ta': getUITA('today-button'),
          }}
        />
      </div>
    );
  }

  return (
    <LookupField
      {...props}
      ui-ta={getUITA('FormCtrl SSTextBox Value')}
      className={classes.root}
      InputProps={{
        inputProps: {
          className: classes.input,
        },
      }}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={translateString('Value')}
      onLookup={onLookup}
      lookupValues={lookupValues}
      enableLookup={enableLookup}
      showLabel={showLabel}
    />
  );
};

export default Value;
